import { AppLayout } from 'layouts';
import type { CommunityDetail } from 'models';
// TODO once we get rid off redux replace this only for new AppLayout
import qs from 'qs';
import type { ReactNode } from 'react';
import { type Location, useLocation, useNavigate } from 'react-router';

import { usePermissions } from 'permissions';
import { Card, ScrollToTop, Skeleton } from 'ui';

import { CommunityHeader, type CommunityTabItem, mapCommunityTabToPathName } from '../components';
import { useCommunityQuery } from '../queries';

const getInvitationToken = (location: Location) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  if (typeof query.invitation_token === 'string') {
    return query.invitation_token;
  }

  return undefined;
};

type P = {
  children: (community: CommunityDetail) => ReactNode;
  communityId: string;
  tab: CommunityTabItem;
};

const CommunityLayout = ({ children, communityId, tab }: P) => {
  const location = useLocation();
  const navigate = useNavigate();

  const invitationToken = getInvitationToken(location);
  const { data, error, isFetching, isLoading, isSuccess } = useCommunityQuery({ communityId, invitationToken });

  const { canViewCommunityMembers, hasMembershipInCommunity } = usePermissions();

  const isMemberInCommunity = hasMembershipInCommunity({ communityId });

  // Permissions
  // TODO maybe move to somewhere else with business logic?
  if (invitationToken && isMemberInCommunity) {
    // TODO: This should not be in feature
    // eslint-disable-next-line sonarjs/void-use -- We dont want to wait for this navigate
    void navigate(mapCommunityTabToPathName(communityId, '/feed'), { replace: true });
    return null;
  }

  if (data && !canViewCommunityMembers({ community: data }) && tab === '/members') {
    // TODO: This should not be in feature
    // eslint-disable-next-line sonarjs/void-use -- We dont want to wait for this navigate
    void navigate(mapCommunityTabToPathName(communityId, '/feed'), { replace: true });
    return null;
  }

  if (isSuccess && !isFetching && tab !== '/about' && !isMemberInCommunity) {
    // TODO: This should not be in feature
    // eslint-disable-next-line sonarjs/void-use -- We dont want to wait for this navigate
    void navigate(mapCommunityTabToPathName(communityId, '/about'), { replace: true });
    return null;
  }

  return (
    <AppLayout error={error}>
      {isLoading || !data ? (
        <Card>
          <Skeleton active avatar className="community-layout__header-skeleton" paragraph={{ rows: 12 }} />
        </Card>
      ) : (
        <>
          <Card shrinked>
            <CommunityHeader community={data} tab={tab} />
          </Card>
          <ScrollToTop />
          {children(data)}
        </>
      )}
    </AppLayout>
  );
};

export default CommunityLayout;
